import { InputField } from "./Inputs";
import { UploadButton } from "./Button";
import { Box, FormControl, FormLabel } from "@mui/material";

import Chip from "@mui/material/Chip";
import CloseIcon from "@mui/icons-material/Close";
import styled from "@emotion/styled";
import { useDispatch } from "react-redux";
import UploadIcon from '@mui/icons-material/Upload';

interface UploadFileInputProps {
  handleUploadDocument: any;
  element: any;
  indexValue: number;
}

const UploadFileInput = ({
  handleUploadDocument,
  element,
  indexValue,
}: UploadFileInputProps) => {


  return (
    <>
      <UploadButton
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        onClick={() => {
          handleUploadDocument(
            element?.docId,
            indexValue
          );
        }}
      >
        <UploadIcon sx={{ fontSize:"15px" }} /> &nbsp; Upload
      </UploadButton>
    </>
  );
};

export default UploadFileInput;
